import React from "react";
import { MessageCircle } from "lucide-react";
import { siteConfig, whatsappLink } from "../mock";

const Hero = () => {
  return (
    <section
      className="relative w-full min-h-[720px] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${siteConfig.heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="relative z-10 w-full max-w-[1240px] px-6 text-center">
        <h1
          className="text-white font-normal leading-[1.1] mb-6"
          style={{
            fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif",
            fontSize: "clamp(56px, 9vw, 130px)",
            letterSpacing: "-0.5px",
            textShadow: "0 2px 20px rgba(0,0,0,0.35)",
          }}
        >
          {siteConfig.brandName}
        </h1>
        <p
          className="text-white/95 mb-10"
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(20px, 2.2vw, 28px)",
            fontWeight: 400,
            letterSpacing: "0.3px",
          }}
        >
          {siteConfig.tagline}
        </p>

        <a
          href={whatsappLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-7 py-3 rounded-md text-white text-[16px] font-medium tracking-wide shadow-lg hover:shadow-xl transform-gpu hover:-translate-y-[1px] transition-all duration-200"
          style={{ backgroundColor: "#3d4a1f" }}
        >
          <MessageCircle className="w-[18px] h-[18px]" />
          <span>whatsapp now</span>
        </a>
      </div>

      {/* subtle bottom fade to blend with next section */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-black/70 pointer-events-none" />
    </section>
  );
};

export default Hero;
